import React from 'react';
import Image from 'next/image';
import { Icon, Button, Typography } from '@/components/common';
import Icons from '@/const/icons';
import Images from '@/const/images';
import { TourStepHeader } from '@/components/modals/guided-tour/TourStepHeader';
import { TourStepTracker } from '@/components/modals/guided-tour/TourStepTracker';
import { GuidedTourStepProps } from '@/interfaces';

export const StepWhereToFindThings: React.FC<GuidedTourStepProps> = ({
	onClose,
	onNext,
	onBack,
	currentStep,
	totalSteps,
}) => {
	return (
		<div className="flex flex-col h-full">
			<TourStepHeader onClose={onClose} className="pt-6">
				<Image
					src={Images.whereToFindThings}
					alt=""
					width={538.31}
					height={354}
				/>
			</TourStepHeader>

			<div className="flex flex-col flex-1 min-h-0 px-5 md:px-10 pt-6 pb-8">
				<Typography
					type="regular-12"
					className="!text-gray-35 uppercase tracking-[0.08em]"
				>
					Step 2 of 3 — Where things happen
				</Typography>

				<Typography type="semibold-24" className="mt-2">
					Where to find things
				</Typography>

				<div className="flex flex-col gap-4 mt-11">
					<div className="flex items-start gap-3">
						<div className="size-10 rounded-full bg-[#EBDFFA80] flex items-center justify-center shrink-0">
							<Icon src={Icons.briefcase} className="!size-6 text-primary" />
						</div>
						<Typography type="regular-18" className="!text-black text-left">
							Your <span className="font-semibold">case page</span> shows your
							progress, your documents, and anything we need from you.
						</Typography>
					</div>
					<div className="flex items-start gap-3">
						<div className="size-10 rounded-full bg-[#EBDFFA80] flex items-center justify-center shrink-0">
							<Icon src={Icons.envelope} className="!size-6 text-primary" />
						</div>
						<Typography type="regular-18" className="!text-black text-left">
							Your <span className="font-semibold">inbox</span> is where
							you&apos;ll hear from your legal team. Check it regularly.
						</Typography>
					</div>
				</div>

				<div className="flex items-center justify-between mt-auto pt-8">
					<TourStepTracker currentStep={currentStep} totalSteps={totalSteps} />
					<div className="flex items-center gap-3">
						<Button
							decoration="ghost"
							size="fit"
							className="!text-primary !px-2"
							onClick={onBack}
						>
							Back
						</Button>
						<Button
							decoration="primary"
							size="fit"
							className="!w-[156px] !h-[48px]"
							onClick={onNext}
						>
							Next
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
